import React from "react";
import Image from "next/image";
import Link from "next/link";

export const Footer: React.FC = () => {
  return (
    <footer className="bg-[#030508] border-t border-gold/10 pt-20 pb-10 px-6 md:px-12 text-left relative z-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 pb-16 border-b border-gold/5">
          <div className="lg:col-span-4 flex flex-col items-start gap-4">
            <div className="flex flex-col items-start">
              <Image
                src="/IMG/logo/logo-200.webp"
                alt="Instituto Copleston Logo"
                width={120}
                height={44}
                className="object-contain filter brightness-90 mb-4 h-11 w-auto"
              />
              <h2 className="font-serif text-lg md:text-xl tracking-wider text-text-pure uppercase font-light">
                Instituto Copleston
              </h2>
              <p className="text-[10px] italic tracking-widest text-gold mt-1 font-serif uppercase">
                Veritas et Sapientia
              </p>
            </div>
            <p className="text-text-muted text-xs md:text-sm font-light leading-relaxed max-w-sm mt-2">
              Formación de alto nivel en Filosofía, Psicología y Pensamiento Estratégico. Para mentes que buscan comprender el mundo con profundidad.
            </p>
            
            <div className="flex items-center gap-4 mt-2">
              <a
                href="https://www.instagram.com/coplestoninstitute/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full border border-gold/10 flex items-center justify-center text-text-muted hover:text-gold hover:border-gold transition-all duration-300"
                aria-label="Instagram"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/coplestoninstitute"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full border border-gold/10 flex items-center justify-center text-text-muted hover:text-gold hover:border-gold transition-all duration-300"
                aria-label="LinkedIn"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.924 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@coplestoninstitute"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full border border-gold/10 flex items-center justify-center text-text-muted hover:text-gold hover:border-gold transition-all duration-300"
                aria-label="YouTube"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@coplestoninstitute"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full border border-gold/10 flex items-center justify-center text-text-muted hover:text-gold hover:border-gold transition-all duration-300"
                aria-label="TikTok"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .8.11v-3.5a6.39 6.39 0 0 0-3.11.8 6.34 6.34 0 0 0-3.38 5.61 6.34 6.34 0 0 0 10.77 4.57 6.24 6.24 0 0 0 1.83-4.57V8.66a8.21 8.21 0 0 0 5.2 1.84V7.07a4.8 4.8 0 0 1-2-1.38 4.75 4.75 0 0 1-1.37-1z" />
                </svg>
              </a>
            </div>
          </div>

          <div className="lg:col-span-3 flex flex-col gap-4">
            <h3 className="font-serif text-sm tracking-widest text-gold uppercase">
              Exploración
            </h3>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link href="/" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link href="/circulo" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Círculo de Estudio
                </Link>
              </li>
              <li>
                <Link href="/escuela-filosofia" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Escuela de Filosofía
                </Link>
              </li>
              <li>
                <Link href="/canal" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Canal de YouTube
                </Link>
              </li>
              <li>
                <Link href="/audiolibros" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Audiolibros
                </Link>
              </li>
              <li>
                <Link href="/podcast" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Podcast Logos
                </Link>
              </li>
              <li>
                <Link href="/ensayos" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Ensayos & Artículos
                </Link>
              </li>
              <li>
                <Link href="/nosotros" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Nosotros
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-4">
            <h3 className="font-serif text-sm tracking-widest text-gold uppercase">
              Rutas de Estudio
            </h3>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link href="/rutas" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Filosofía del Poder
                </Link>
              </li>
              <li>
                <Link href="/rutas" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Arquitectura de la Mente
                </Link>
              </li>
              <li>
                <Link href="/rutas" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Historiología y Filosofía
                </Link>
              </li>
              <li>
                <Link href="/rutas" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Pensamiento Estratégico
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3 flex flex-col gap-4">
            <h3 className="font-serif text-sm tracking-widest text-gold uppercase">
              Contacto
            </h3>
            <a
              href="mailto:contacto@coplestoninstitute.com"
              className="text-xs font-light text-text-pure/80 hover:text-gold transition-colors duration-300 break-words"
            >
              contacto@coplestoninstitute.com
            </a>
            <ul className="flex flex-col gap-2.5 mt-2">
              <li>
                <Link href="/terminos" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Términos del Servicio
                </Link>
              </li>
              <li>
                <Link href="/privacidad" className="text-xs font-light text-text-muted hover:text-gold transition-colors">
                  Política de Privacidad
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-10 text-[10px] tracking-wider text-text-muted/80 uppercase font-light">
          <span>
            © {new Date().getFullYear()} Instituto Frederick Charles Copleston. 100% Libre y Gratuito.
          </span>
          <span className="flex items-center gap-2">
            Veritas et Sapientia &nbsp;·&nbsp; Cusco, Perú
          </span>
        </div>
      </div>
    </footer>
  );
};
